import { OAuthTokensTable } from '@/components/iam/OAuthTokensTable';

export const UserOAuthTokensTab = ({ userId }: { userId: number }) => (
  <OAuthTokensTable
    filter={{ field: 'user_id', value: userId }}
    titleKey="iam.users.tabs.oauth_tokens"
  />
);
